import { Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyWord } from 'src/app/shared/classes/constants';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { KeywordData } from '../../shared/classes/keywordData';
import { Socket } from 'ngx-socket-io';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import * as countries from '../../shared/countries.json'
import { Location, LocationStrategy } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { CalculateClusterService } from 'src/app/shared/services/calculateCluster.service';
import Gleap from 'gleap';
import { LckrService } from 'src/app/shared/services/lckr.service';
import { BulkContentEditorComponent } from 'src/app/content-editor/bulk-content-editor/bulk-content-editor.component';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-dashboard2',
  templateUrl: './dashboard2.component.html',
  styleUrls: ['./dashboard2.component.scss']
})
export class Dashboard2Component implements OnInit,OnDestroy {
  local_setting: boolean = false
  Lists: any = []
  listName: any = ''
  separateExcelLoader: boolean = false
  exclude_any_keywords: any = []
  exclude_fix_keywords_backup: any = []
  include_fix_keywords: any = []
  include_any_keywords: any = []
  allSelect: boolean = false;
  isOpen: boolean = false
  excludeKeyword: any = ''
  includeKeyword: any = ''
  clusterExcelLoader: boolean = false
  excelLoader: boolean = false
  selectedData: boolean = false
  allDataSelected: boolean = false
  userName: any = ""
  hideKeywordAry: any[] = []
  keyWordCountry: string = ''
  keyWordLanguage: string = ''
  keyWordName: string = ""
  isAllChecked: boolean = false;
  topicData: any[] = [];
  backupTopicData: any[] = [];

  openPopup: boolean = false;
  title: string = '';
  panelOpenState: boolean = false;
  panelOpenStatetopic: boolean = false;
  isSidebarOpen: boolean = true;

  activateLink: string = 'all';
  includedWords: string[] = []
  excludedWords: string[] = [];
  paginateData: any = {};
  includeWord = new FormControl('');
  excludeWord = new FormControl('');
  countedWord: number = 0;
  checked: boolean = false;
  keyWordData: any[] = [];
  backupKeyWordData: KeywordData[] = []

  masterSelected!: boolean;
  page: number = 1;
  count: number = 4;
  tableSize: any = "50";
  backUptableSize: any = "50";
  searchText: string = ""
  totalData: string = "0";
  keyWordArray = KeyWord.keyWordArray;
  theme: boolean = true;
  matMenuName: any;
  matMenuItemArray: any[] = [];
  lckrKeyWordData: any[] = [];
  selectedMainKeyWordData: any = [];
  tabWiseCount: number = 100000000;
  matMenuArg: string = '';
  lid: any = "";
  statusMenuArray = KeyWord.statusMenuArray
  intentMenuArray = KeyWord.intentMenuArray;
  weakSpotMenuArray = KeyWord.weakSpotMenuArray;
  formusMenuArray = KeyWord.formusMenuArray;
  analyseMenuArray = KeyWord.analyseMenuArray;
  serpScoreMenuArray = KeyWord.serpScoreMenuArray;
  paaLength: number = 0;
  suggestionLength: number = 0;
  questionLength: number = 0;
  compitionLength: number = 0;
  relatedLength: number = 0;
  loading: boolean = false;
  topicloading: boolean = false;
  keyWordId: any = "";
  queryString: string = "";
  allLength: number = 0;
  weakSpotFilter: string[] = [];
  volFilter = { max: "", min: "" };
  cpcFilter = { max: "", min: "" };
  intentFilter: string[] = [];
  statusFilter: string[] = [];
  forumFilter: string[] = [];
  topicFilter: string[] = [];
  serpScoreFilter: string[] = [];
  suggestion: number = 0;
  question: number = 0;
  all: number = 0;
  clickCount: number = 0;
  getkeywords: string[] = [];
  dataskeyword: any;
  newword: any;

  visible = true;
  volUparrow: boolean = false;
  volDownarrow: boolean = false;

  totalKeywordUpArrow: boolean = false;
  totalKeywordDownArrow: boolean = false;
  weakKeywordUpArrow: boolean = false;
  weakKeywordDownArrow: boolean = false;
  ldaUpArrow: boolean = false;
  ldaDownArrow: boolean = false;
  cpcUpArrow: boolean = false;
  cpcDownArrow: boolean = false;
  serpUpArrow: boolean = false;
  serpDownArrow: boolean = false;
  weakSpotUpArrow: boolean = false;
  weakSpotDownArrow: boolean = true;
  backupKeyWordArray: any[] = [];
  waiting8MinutesArray: any[] = [];
  waiting8MinutesBackupArray: any[] = [];
  hideArray: any[] = [];
  backupHideArr: any[] = [];
  hiddenDataBackupArr: any[] = [];
  hiddenDataLength: number = 0;
  selectedKeyWordDatas: any[] = [];
  selectedMainKeyWordDatas: any[] = [];
  uid: any = '';
  jumpToPageCount: number = 1;
  sortedBackupKeywordData: any[] = [];
  // Tabs variables
  allPaginateData: any[] = [];
  suggestionPaginateData: any = [];
  questionsPaginateData: any = [];
  paaPaginateData: any[] = [];
  hiddenPaginateData: any = [];
  relatedSearchedPaginateData: any[] = [];
  competitionPaginateData: any[] = [];
  display = 'none';
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  confirmationPopupData: string = '';
  highintentLength: number = 0;
  postPurchaseLength: number = 0;
  prePurchaseLength: number = 0;
  comparisionLength: number = 0;
  wholeKeywordReportLength: number = 0;
  checkVolFilterAvailable: boolean = false;
  checkCpcFilter: boolean = false;
  checkTopicFlter: boolean = false;
  buttonArg: any[] = [];
  keyWordType: string | null = "";
  activeFilterCount = 0;
  countryValues: any = countries;
  searchTopic: string = "";
  cookies: any = "";
  isLogin: boolean = true;
  exportData: any[] = [];
  exportSelectedData: any[] = [];
  checkStatus: boolean = false;
  overAllanalyse: number = 0;
  completedAnalyse: number = 0;
  clusterData: any[] = [];
  topResults: string = "10";
  SERPSimilarity: string = "3";
  isCollapsed = false;
  clusterLength: number = 0;
  top10Data: any[] = [];
  panels = ['First', 'Second', 'Third'];
  clusteredData: any[] = [];
  clusterBindingData: any = [];
  isClicked: boolean = false;
  eventSubscription: any
  daLessthan10: boolean = false;
  daLessthan20: boolean = false;
  showPopup: boolean = false;
  cutrrentPop: any;
  selectedClusterId: any[] = [];
  selectedSubClusterId: any[] = [];
  // settingsData: any = {};
  settingsData: {
    maxDa: number,
    mySites: string[],
    customDomain: string[],
    type: string,
    theme: any
  } = {
      maxDa: 30,
      mySites: [],
      customDomain: [],
      type: "",
      theme: this.theme
    }
  settingObj: any = {}
  showDataFetching: boolean = false;
  queryFilterParams: any = [];
  isVolActive: boolean = false;
  isCpcActive: boolean = false;
  filterQuery: string = ``;
  searchTimeOutId!: any;
  subClusterData: any[] = [];
  sortArray: any[] = [];
  allCount: number = 0;
  checkArr: number[] = [];
  ids: number[] = [];
  lckrCountData: any = {};
  isDisable: boolean = false;
  currenturlParams?: any;
  savedIds: number[] = []
  userData: any;
  clustersloading: boolean = false;
  unsubscribe: Subject<void> = new Subject();

  get menu() {
    return this.theme ? 'providers-menu' : ''
  }

  get popover() {
    return !this.theme ? 'dark-popover ' : ''
  }

  get customPopover() {
    return !this.theme ? 'custom-popover ' : ''
  }

  @HostListener('window:scroll', [])
  onWindowScroll(event: any) {
    if (event.srcElement.scrollTop >= 100) {
      this.showPopup = true;
    } else {
      this.showPopup = false;
    }
  }
  constructor(private themingService: ThemingService,
    private modal: NgbModal,
    private editorService: EditorService,
    private lckrService: LckrService,
    private route: ActivatedRoute,
    private socket: Socket,
    public _snackBar: MatSnackBar,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private location: Location,
    private cookieServ: CookieService,
    private clustureService: CalculateClusterService,
    private router: Router,
    private editorServie: EditorService,
    private locationStrategy:LocationStrategy

  ) {
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res;
      this.settingsData.theme = res;
    })

    this.loading = true;
    this.route?.params?.subscribe(params => {
      let keyWordId = params['id'];
      this.themingService.setId(params['id'])
      if (!!keyWordId) sessionStorage.setItem("keyWordId", keyWordId)
      this.keyWordId = sessionStorage.getItem("keyWordId");
    });
    this.panelOpenState = false;
    this.route?.queryParams?.subscribe(params => {
      let keyWordType = params['type'];
      if (!!keyWordType) sessionStorage.setItem("keyWordType", keyWordType)
    });

    this.keyWordType = sessionStorage.getItem("keyWordType")
    this.keyWordType == 'list' ? this.isSidebarOpen = false : this.isSidebarOpen = true
    this.uid = this.cookieServ.get("uid");
    this.userName = this.cookieServ.get("userName");
    this.sortArray.push('-serp_score_count')
    // this.location.replaceState(`/lckr/dashboard2/${this.keyWordId}`);
    if (!this.uid || !localStorage.getItem('auth_token')) {
      this.isLogin = false
    }
    if (!!this.keyWordId && this.keyWordType != 'list') {
      this.lckrService.getSocketRes(this.keyWordId).subscribe((res: any) => {
        if(res && Array.isArray(res)){
          if (!!res && res.length > 0) {
            // this.ids = keyWordArray
            res.forEach((el: any) => {
              for (let key in el) {
                if (!this.ids.includes(Number(key))) {
                  this.ids.push(Number(key))
                }
              }
            })
          } else {
            this.checkArr = [];
            this.ids = []
            this.filterQueryBuilder('noLoadArg');
          }
        }else{
          if(res.excel_running){
            
          }else{
            let dwldLink = document.createElement("a");
            let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
            if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
              dwldLink.setAttribute("target", "_self");
            }
            dwldLink.setAttribute("href", res.path);
            dwldLink.setAttribute("download", res.path);
            dwldLink.style.visibility = "hidden";
            document.body.appendChild(dwldLink);
            dwldLink.click();
            document.body.removeChild(dwldLink);
    
            // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
            this.excelLoader = false
          }
        }
   
      })
    }
    if(this.keyWordType === 'list'){
      this.lckrService.getListSocketRes(this.keyWordId).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
          if(!Array.isArray(res) && !res.excel_running){
            let dwldLink = document.createElement("a");
            let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
            if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
              dwldLink.setAttribute("target", "_self");
            }
            dwldLink.setAttribute("href", res.path);
            dwldLink.setAttribute("download", res.path);
            dwldLink.style.visibility = "hidden";
            document.body.appendChild(dwldLink);
            dwldLink.click();
            document.body.removeChild(dwldLink);
    
            // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
            this.excelLoader = false
          } 
      })
    }
  }
  ngOnInit(): void {
    this.themingService.pingThemeName();
    if(this.uid){
      this.getUserDetails();
    }
    if (this.uid && !!this.keyWordId && this.keyWordType != 'list') {
      this.restoreState();
      this.compareAndSetSettings();
      // this.getTabsCount();
      this.gettopicdata();
      this.getListNames();
      this.getExcludes();
    } else if (this.keyWordType === 'list') {
      // this.getGlobalSettingData()
      this.filterQueryBuilder();
      setTimeout(() => {
        let isRunning = this.paginateData.some((e: any) => { return e.status === 'R' });
        if (isRunning) {
          this.paginateData[0].lid.forEach((e: any) => {
            this.lckrService.getSocketRes(e).subscribe((res: any) => {
              if (!!res && res.length > 0) {
                // this.ids = keyWordArray
                res.forEach((el: any) => {
                  for (let key in el) {
                    if (!this.ids.includes(Number(key))) {
                      this.ids.push(Number(key))
                    }
                  }
                })
              } else {
                this.checkArr = [];
                this.ids = []
                this.filterQueryBuilder('noLoadArg');
              }
            })
          });
        }
      }, 2000);
      // this.getListData();
    }
    this.editorService.getFlag().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      if (res == false) {
        this.settingObj.type = "local"
        this.editorService.sendLocalSettingData(this.settingObj)
        this.settingsData.maxDa = this.settingObj.maxDa
        this.settingsData.customDomain = this.settingObj.customDomain
        this.settingsData.mySites = this.settingObj.mySites
        this.settingsData.type = "local"
        this.settingsData.theme = this.theme
        // this.getSuggestionAndQuestion();
        // this.changePaginateData();
      } else if (res == true) {
        this.settingObj.type = "global"
        this.settingsData.type = "global"
        this.editorService.saveGlobalSettingTrue({ lid: this.keyWordId }).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
          if (res) {
            // this.getGlobalSettingData()
            // this.getAllData()
            this.toastr.info("global setting update successfully")
          }
        })
      }
    })
  }
  
  getUserDetails() {
    this.editorService.getUserprofile({ uid: this.uid }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.userData = res.userDetails[0];
    })
  }
  restoreState() {
    this.route.queryParams.subscribe(params => {
      this.currenturlParams = params;
      if (this.activateLink !== 'clusters') {
        this.backUptableSize = params.page_size ? params.page_size == '10' ? '50' : params.page_size : '50';
        params.page_size
      }
      if (!Number.isNaN(Number(params.page))) {
        this.page = Number(params.page)
      }
    });
    Object.keys(this.currenturlParams).forEach(el => {
      if (!Array.isArray(this.currenturlParams[el])) {
        if (el === "intent" && this.currenturlParams[el] === "HI") {
          this.intentFilter.push("high_intent")
        }
        if (el === "intent" && this.currenturlParams[el] === "PP") {
          this.intentFilter.push("pre_purchase")
        }
        if (el === "intent" && this.currenturlParams[el] === "PB") {
          this.intentFilter.push("post_purchase")
        }
        if (el === "intent" && this.currenturlParams[el] === "C") {
          this.intentFilter.push("comparison")
        }
        if (el === "status_analyzed" && this.currenturlParams[el] === "true") {
          this.statusFilter.push("analyzed")
        }
        if (el === "status_analyzed" && this.currenturlParams[el] === "false") {
          this.statusFilter.push("not_analyzed")
        }
        if (el === "volume_min") {
          this.isVolActive = true;
          this.volFilter.min = this.currenturlParams[el]
        }
        if (el === "volume_max") {
          this.isVolActive = true;
          this.volFilter.max = this.currenturlParams[el]
        }
        if (el === "cpc_min") {
          this.isCpcActive = true;
          this.cpcFilter.min = this.currenturlParams[el]
        }
        if (el === "cpc_max") {
          this.isCpcActive = true;
          this.cpcFilter.max = this.currenturlParams[el]
        }

        if (el === "weak_spot_top_10") {
          this.weakSpotFilter.push("At least 1 (in top 10)")
        }
        if (el === "weak_spot_top_3") {
          this.weakSpotFilter.push("At least 1 (in top 3)")
        }
        if (el === "weak_spot_1") {
          this.weakSpotFilter.push("At least 1 (with Low DA)")
        }
        if (el === "no_weak_spot") {
          this.weakSpotFilter.push("No weak spots")
        }
        if (el === "forum_top_3") {
          this.forumFilter.push("At least 1 (in top 3)")
        }
        if (el === "serp_score" && this.currenturlParams[el] === "H") {
          this.serpScoreFilter.push("High")
        }
        if (el === "serp_score" && this.currenturlParams[el] === "M") {
          this.serpScoreFilter.push("Medium")
        }
        if (el === "serp_score" && this.currenturlParams[el] === "L") {
          this.serpScoreFilter.push("Low")
        }
        if (el === "da_10") {
          this.daLessthan10 = true;
        }
        if (el === "da_20") {
          this.daLessthan20 = true;
        }
        if (el === "topics") {
          this.topicFilter = this.currenturlParams[el].split(",");
          // delete this.currenturlParams[el];
        }
        if (el === "search") {
          this.searchText = this.currenturlParams[el];
          // delete this.currenturlParams[el];
        }
        if (el === "type" && this.currenturlParams[el] === "S") {
          this.activateLink = "suggestion";
          // delete this.currenturlParams[el];
        }
        if (el === "type" && this.currenturlParams[el] === "Q") {
          this.activateLink = "question";
          // delete this.currenturlParams[el];
        }
        if (el === "hidden" && this.currenturlParams[el] === "True") {
          this.activateLink = "hidden";
          // delete this.currenturlParams[el];
        }
        if (el === "active" && this.currenturlParams[el] === "paa") {
          this.activateLink = "paa";
          // delete this.currenturlParams[el];
        }
        if (el === "active" && this.currenturlParams[el] === "related_search") {
          this.activateLink = "related_search";
          // delete this.currenturlParams[el];
        } if (el === "active" && this.currenturlParams[el] === "competition") {
          this.activateLink = "competition";
          // delete this.currenturlParams[el];
        }
        if (el === "active" && this.currenturlParams[el] === "cluster") {
          this.activateLink = "clusters";
          // delete this.currenturlParams[el];
        }
      } else if (!!Array.isArray(this.currenturlParams[el])) {
        if (el === "intent" && this.currenturlParams[el].includes("HI")) {
          this.intentFilter.push("high_intent")
        }
        if (el === "intent" && this.currenturlParams[el].includes("PP")) {
          this.intentFilter.push("pre_purchase")
        }
        if (el === "intent" && this.currenturlParams[el].includes("PB")) {
          this.intentFilter.push("post_purchase")
        }
        if (el === "intent" && this.currenturlParams[el].includes("C")) {
          this.intentFilter.push("comparison")
        }
        if (el === "serp_score" && this.currenturlParams[el].includes("H")) {
          this.serpScoreFilter.push("High")
        }
        if (el === "serp_score" && this.currenturlParams[el].includes("M")) {
          this.serpScoreFilter.push("Medium")
        }
        if (el === "serp_score" && this.currenturlParams[el].includes("L")) {
          this.serpScoreFilter.push("Low")
        }
      }
    })

    this.filterQuery = this.router.url.split('?')[1];
    this.filterQueryBuilder();
  }
  getExcludes() {
    this.lckrService.getIncludeExclude(this.keyWordId, 'E').pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (!!res) {
        // this.toastr.info("keywords excludes successfully")
        // keyword_ary = []
        let ress = res.filter((el: any) => { return el.type === 'E' })
        this.exclude_any_keywords = ress;
        // this.filterQueryBuilder()
        // this.excludeKeyword = ''
      }
    })
  }
  getListData() {
    this.lckrService.getListDetails({ "type": "get_data", "lckrlist_id": this.keyWordId }, this.filterQuery).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (!!res) {
        this.keyWordName = res.lckrlist_name
        res.keywords.forEach((el: any) => {
          el['isChecked'] = (!!this.checkArr.includes(el.id) || !!this.allSelect) ? true : false;
          el['id'] = el.kid;
          el['lid'] = res.lowfruit_lids;
          el['lckrlist'] = el?.lckrlist;
          if (el.serp.length > 0) {
            el['serpPosition'] = el.serp.map((e: any) => {
              let positionArr: any = [];
              let keys = Object.keys(e).filter(k => e[k] === true);
              if (keys.length === 0) {
                positionArr = [{ key: "all false", da: {} }];
              } else {
                for (const key in e) {
                  if (typeof e[key] == "boolean") {
                    if (e[key] == true && e[key]) {
                      if (positionArr.length == 0) {
                        if (key === "lowda" && e.data_lowda.da < this.settingsData.maxDa) {
                          positionArr.push({ key: key, da: e.data_lowda });
                        } else {
                          positionArr.push({ key: key, da: {} });
                        }
                      }
                    }
                  }
                }
              }
              return { domain: e.domain, isCustomDomain: this.settingsData.customDomain.includes(e.domain) ? true : false, isMySites: this.settingsData.mySites.includes(e.domain) ? true : false, title: e.title, link: e.link, position: e.position, serp: positionArr }
            })
          } else {
            el['serpPosition'] = []
          }

        });
        this.allCount = res.total_record;
        this.allPaginateData = res.keywords;
        this.loading = false;
        this.changePaginateData();
        this.masterSelected = (!this.allSelect && this.allPaginateData.every(e => !!e.isChecked)) ? true : false
      }
    })
  }
  compareAndSetSettings() {
    this.lckrService.postGlobalSettings({
      "main_type": "individual_lckr_settings",
      "type": "get_local_settings",
      "lid": this.keyWordId
    }).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      let localSetings = res;
      if (!localSetings.local_setting) {
        this.lckrService.postGlobalSettings({
          "main_type": "global_settings",
          "type": "get_global_settings",
          "uid": this.uid
        }).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
          let globalSettings = res[0];
          globalSettings.highlight_domains.forEach((e: any) => {
            this.settingsData.customDomain.push(e.domain)
          })
          globalSettings.mysite_domains.forEach((e: any) => {
            this.settingsData.mySites.push(e.domain)
          })
          this.settingsData.maxDa = globalSettings.max_da;
          this.settingsData.type = "global";
        });
      } else {
        this.settingsData.customDomain = localSetings.highlight_domains,
          this.settingsData.mySites = localSetings.mysite_domains,
          this.settingsData.maxDa = localSetings.max_da;
      }
    });

  }

  ngOnDestroy(): void {
    sessionStorage.removeItem("topicsdata");
    this.socket.removeListener("lowfruitAnalysisCompleted");
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  getDashboardData() {
    this.lckrService.getDashboardData(this.filterQuery).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (!!res) {
        res.results.forEach((el: any) => {
          el['isChecked'] = (!!this.checkArr.includes(el.id) || !!this.allSelect) ? true : false
          if (el.serp.length > 0) {
            el['serpPosition'] = el.serp.map((e: any) => {
              let positionArr: any = [];
              let keys = Object.keys(e).filter(k => e[k] === true);
              if (keys.length === 0) {
                positionArr = [{ key: "all false", da: {} }];
              } else {
                for (const key in e) {
                  if (typeof e[key] == "boolean") {
                    if (e[key] == true && e[key]) {
                      if (positionArr.length == 0) {
                        if (key === "lowda" && e.data_lowda.da < this.settingsData.maxDa) {
                          positionArr.push({ key: key, da: e.data_lowda });
                        } else {
                          positionArr.push({ key: key, da: {} });
                        }
                      }
                    }
                  }
                }
              }
              return { domain: e.domain, isCustomDomain: this.settingsData.customDomain.includes(e.domain) ? true : false, isMySites: this.settingsData.mySites.includes(e.domain) ? true : false, title: e.title, link: e.link, position: e.position, serp: positionArr }
            })
          } else {
            el['serpPosition'] = []
          }

        });
        this.allCount = res.count
        this.allPaginateData = res.results;
        this.loading = false;
        this.changePaginateData();
        this.getTabsCount();
        this.masterSelected = (!this.allSelect && this.allPaginateData.every(e => !!e.isChecked)) ? true : false
      }
    })
  }
  toggleCollapse(): void {
    this.visible = !this.visible;
  }
  openPop(popup?: any) {
    if (!!popup) {
      this.cutrrentPop = popup
      popup.open();
    } else {
      this.cutrrentPop.open();
    }

  }
  openPopp(index?: number) {
    let doc = document.getElementById(`divv${index}`);
    doc!.style.background = "transparent";
    doc!.style.opacity = "0";
  }
  closePop(index: number) {
    this.cutrrentPop?.close();
  }
  refreshData() {
    window.location.reload();
  }

  gettopicdata() {
    this.lckrService.getTopics({ lid: this.keyWordId }).pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      // this.loading = false;
      this.newword = res
      if (sessionStorage.getItem("topicsdata")) {
        this.topicloading = true
      }
      else {
        this.topicloading = false
      }
      sessionStorage.setItem("topicsdata", JSON.stringify(this.newword));
      this.displaytopic()
    })
  }

  displaytopic() {
    let topicdatas: any = [];
    topicdatas = sessionStorage.getItem("topicsdata");
    this.topicloading = true;
    if (topicdatas != null) {
      this.topicloading = false
      this.topicData = topicdatas
      this.topicData = JSON.parse(topicdatas).map((topics: string) => {
        let datas = topics.replace(/\"/g, "")
        return { datas, isSelected: false }
      });
      this.backupTopicData = JSON.parse(topicdatas).map((topics: string) => {
        let datas = topics.replace(/\"/g, "")
        return { datas, isSelected: false }
      });

    }
    else {
      this.topicloading = false
      if (this.newword.length > 0) {
        this.topicData = this.newword
        this.topicData = this.topicData.map(topics => {
          let datas = topics.replace(/\"/g, "")
          return { datas, isSelected: false }
        })
      }
    }
  }
  filterTopic() {
    this.topicData = this.backupTopicData.filter(el => el.datas.toLowerCase().search(this.searchTopic.toLowerCase()) >= 0)
  }

  openPopupover(data: string) {
    this.openPopup = true;
    this.title = data;
  }
  showKey(data: any) {
    if (data.isPaa) {
      return 'PAA';
    } else if (data.isRelated) {
      return 'Related';
    } else {
      return ''
    }
  }

  isPopupClose(data: any) {
    this.openPopup = data
  }
  voluman_data: any = []

  changePaginateData(arg?: string, optionalArg?: string, loadingArg?: string) {
    if (!!optionalArg && optionalArg === 'resetPagination') {
      this.page = 1;
      this.jumpToPageCount = this.page;
    }
    if (this.activateLink == 'all' || this.activateLink == 'suggestion' || this.activateLink == 'question' || this.activateLink == 'hidden' || this.activateLink == 'paa' || this.activateLink == 'related_search' || this.activateLink === 'competition' || this.activateLink === 'clusters') {
      this.paginateData = this.allPaginateData;
      this.keyWordData = this.allPaginateData;
      this.backupKeyWordData = this.allPaginateData;
      this.onTableDataChange();
    }
    // else if (this.activateLink === 'clusters') {
    //   if (!!this.clusteredData && this.clusteredData?.length > 0) {
    //     this.clusteredData = this.clusteredData.map(e => {
    //       return { ...e, page: 1 }
    //     })
    //     this.paginateData = this.clusteredData;
    //     this.keyWordData = this.clusteredData;
    //     this.backupKeyWordData = this.clusteredData;
    //     this.onTableDataChange();
    //   } else {
    //     this.paginateData = [];
    //     this.keyWordData = [];
    //     this.backupKeyWordData = [];
    //     this.onTableDataChange();
    //   }
    // } 
    else {
      this.paginateData = [];
      this.keyWordData = [];
      this.backupKeyWordData = [];
      this.onTableDataChange();
    }
  }
  activeLink(data: string) {
    if (data !== this.activateLink) {
      this.page = 1;
      if (this.activateLink == 'clusters') {
        this.tableSize = "10";
      }
      // else{
      //   this.tableSize = "50"
      // }
      this.paginateData = [];
      this.keyWordData = []
      this.backupKeyWordData = [];
      this.activateLink = data;
      this.masterSelected = false;
      this.allSelect = false;
      this.checkArr = [];
      this.savedIds = [];
      this.filterQueryBuilder()
    }
  }
  buttonState() {
    return !this.keyWordData?.some(_ => _.isChecked);
  }
  deleteWord(data: string, title: string) {
    title === 'Include' ? this.includedWords = this.includedWords.filter(i => i !== data) : this.excludedWords = this.excludedWords.filter(e => e !== data)
  }
  topicclear() {
    this.topicData.forEach(element => {
      element.isSelected = false
    })
    this.topicFilter = [];
    let filterdData = this.backupKeyWordData;
    if (this.topicFilter.length > 0) {
      this.topicFilter.forEach((element) => {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes(element))
        })
      })
    }
    if (this.checkTopicFlter) {
      this.activeFilterCount = this.activeFilterCount - 1;
    }
    this.checkTopicFlter = false;
    this.paginateData = filterdData;
    this.keyWordData = filterdData;
    this.filterQueryBuilder();
    this.countedWord = this.topicData.filter(e => { return e.isSelected === true }).length
  }

  selectChip(data: any) {
    this.topicData.forEach(element => {
      if (element.datas == data.datas) {
        element.isSelected = !element.isSelected;
        if (this.topicFilter.includes(data.datas)) {
          element.isSelected = false;
          this.topicFilter = this.topicFilter.filter(e => {
            return e !== element.datas;
          })
        }
        if (element.isSelected == true) {
          this.topicFilter.push(element.datas);
        }
        else {
          this.topicFilter = this.topicFilter.filter(e => {
            return e !== element.datas;
          })
        }
      }
    });
    // if (this.topicFilter.length > 0) {
    //   this.filterQueryBuilder();

    // }
    if (this.topicFilter.length > 0) {
      if (!this.checkTopicFlter) {
        this.activeFilterCount = this.activeFilterCount + 1;
      }
      this.checkTopicFlter = true;
    } else {
      if (this.checkTopicFlter) {
        this.activeFilterCount = this.activeFilterCount - 1;
        // this.filterData();
      }
      this.checkTopicFlter = false;
    }
    this.paginateData.forEach((e: any) => {
      e.isChecked = false
    });
    this.masterSelected = false;
    this.allSelect = false
    this.countedWord = this.topicData.filter(e => { return e.isSelected === true }).length
    this.filterQueryBuilder('filters');
  }
  CheckAll() {
    // this.checkArr = [];
    if (this.activateLink === 'all' || this.activateLink == 'suggestion' || this.activateLink == 'question' || this.activateLink == 'hidden'
      || this.activateLink === 'paa' || this.activateLink == 'competition' || this.activateLink == 'related_search') {
      for (let i = 0; i < this.paginateData.length; i++) {
        this.paginateData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
        this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
      }
      if (this.paginateData.length > 0) {
        this.paginateData.forEach((el: any) => {
          if (!this.checkArr.includes(el.id) && !!el.isChecked) {
            this.checkArr.push(el.id);
          } else if (this.checkArr.includes(el.id) && !el.isChecked) {
            this.checkArr = this.checkArr.filter(ell => ell !== el.id);
          }
        })
      }
    } else {
      for (let i = 0; i < this.paginateData.length; i++) {
        this.paginateData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
        this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
      }
    }
  }
  openModel(content: any) {
    this.modal.open(content, { centered: true });
  }
  allPageSelect() {
    this.checkArr = [];
    for (let i = 0; i < this.paginateData.length; i++) {
      this.paginateData[i].isChecked = this.allSelect;
      this.isAllChecked = this.allSelect;
    }
    for (let i = 0; i < this.keyWordData.length; i++) {
      this.keyWordData[i].isChecked = this.allSelect
    }
    if (this.activateLink === 'all' || this.activateLink == 'suggestion' || this.activateLink == 'question' || this.activateLink == 'hidden'
      || this.activateLink === 'paa' || this.activateLink == 'competition' || this.activateLink == 'related_search') {
      for (let i = 0; i < this.paginateData.length; i++) {
        this.paginateData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
        this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
        this.masterSelected = false
      }
    }
    // }
  }

  clearAllFilter() {
    this.loading = true;
    this.weakSpotFilter = [];
    this.forumFilter = [];
    this.intentFilter = [];
    this.statusFilter = [];
    this.searchText = '';
    this.topicFilter = [];
    this.serpScoreFilter = [];
    this.searchTopic = "";
    // this.displaytopic();
    // this.topicclear();
    this.cpcFilter = {
      min: "",
      max: ""
    }
    this.isCpcActive = false
    if (this.checkCpcFilter) {
      this.activeFilterCount = this.activeFilterCount - 1;
    }
    this.checkCpcFilter = false;
    this.volFilter = {
      min: "",
      max: ""
    }
    this.isVolActive = false;
    if (this.checkVolFilterAvailable) {
      this.activeFilterCount = this.activeFilterCount - 1;
    }
    this.checkVolFilterAvailable = false;
    this.daLessthan10 = false;
    this.daLessthan20 = false;
    this.activeFilterCount = 0;
    this.queryFilterParams = [];
    this.filterQueryBuilder();
  }
  isAllSelected() {
    // this.savedIds = [];
    if (this.activateLink === 'all' || this.activateLink == 'suggestion' || this.activateLink == 'question' || this.activateLink === 'hidden' || this.activateLink === 'paa' || this.activateLink === 'related_search' || this.activateLink === 'competition') {
      if (!this.allSelect) {
        this.masterSelected = this.paginateData.every((item: KeywordData) => {
          return item.isChecked == true;
        });
      } else {
        this.masterSelected = false;
      }
      this.isAllChecked = this.paginateData.some((e: any) => {
        return e.isChecked == true;
      })
      if (this.paginateData.length > 0) {
        this.paginateData.forEach((el: any) => {
          if (!this.checkArr.includes(el.id) && !!el.isChecked) {
            this.checkArr.push(el.id);
          } else if (this.checkArr.includes(el.id) && !el.isChecked) {
            this.checkArr = this.checkArr.filter(ell => ell !== el.id);
          }
        })
      }
    } else {
      this.masterSelected = this.keyWordData.every((item: KeywordData) => {
        return item.isChecked == true;
      });
    }

  }
  onTableDataChange() {
    this.masterSelected = false;
    const lastIndex = this.page * this.tableSize;
    const firstIndex = lastIndex + 1 - this.tableSize;
    this.tabWiseCount = this.getTabCount();
    const pageCount = this.tabWiseCount / this.tableSize;
    this.count = Math.ceil(pageCount);
    if (this.page == this.count) {
      this.totalData = firstIndex + "-" + this.tabWiseCount
    } else {
      this.totalData = firstIndex + "-" + lastIndex
    }
    this.paginateData = this.keyWordData;
    this.loading = false;
  }
  getTabCount() {
    return this.allCount
  }

  filterValue(arg: string, num1: string, num2: string) {
    if (arg == 'vol') {
      this.isVolActive = true;
    } else {
      this.isCpcActive = true;
    }
    this.filterQueryBuilder('filters');
  }
  clearFilter(filterName: string) {
    if (filterName == "cpc") {
      this.cpcFilter = {
        min: "",
        max: ""
      }
      this.isCpcActive = false
      if (this.checkCpcFilter) {
        this.activeFilterCount = this.activeFilterCount - 1;
      }
      this.checkCpcFilter = false;
    }

    if (filterName == "vol") {
      this.volFilter = {
        min: "",
        max: ""
      }
      this.isVolActive = false;
      if (this.checkVolFilterAvailable) {
        this.activeFilterCount = this.activeFilterCount - 1;
      }
      this.checkVolFilterAvailable = false;

    }
    this.filterQueryBuilder('filters')
  }

  onDelete() {
    const check = this.keyWordData.every(e => e.isChecked === true);
    if (check) {
      this.keyWordData.length = 0;
      this.onTableDataChange();
      this.masterSelected = false;
      this.allSelect = false
    } else {
      this.keyWordData.forEach((e, index) => {
        if (e.isChecked) {
          this.keyWordData.splice(index, 1);
          this.onTableDataChange();
        }
      })
    }
    this.modal.dismissAll();
  }
  keyword_id: any
  performSerpExtract(analyseArr?: any[], keyword?: string, arg?: string) {
    this.isDisable = true;
    let keyWordArray: any = [];
    this.keyWordArray = [];
    this.waiting8MinutesArray = this.waiting8MinutesArray.filter((v: any) => v != keyword);
    if (arg === "retryAll") {
      this.waiting8MinutesArray.forEach((e: any) => {
        keyWordArray.push(e);
        this.backupKeyWordArray.push(e)
      })
    }
    else if (keyword != "" && keyword != undefined) {
      keyWordArray.push(keyword);
      this.backupKeyWordArray = [];
      this.waiting8MinutesBackupArray.push(keyword);
      this.waiting8MinutesArray.splice(this.waiting8MinutesArray.indexOf(keyword), 1);
    }
    else {
      if (this.buttonArg.length === 0) {
        this.keyWordData.forEach((e: any) => {
          if (e.isChecked) {
            if (!this.ids.includes(e.id)) {
              keyWordArray.push(e.id);
              this.backupKeyWordArray.push(e.keyword)
            }
          }
        })
      }
    }

    let payloadObj: any = {}
    let analyseTypeQuery = "";
    let analyseType: any = ''
    if (this.buttonArg.length > 0) {
      if (this.buttonArg.includes('High - Intent')) {
        analyseType = "high_intent"
      } else if (this.buttonArg.includes('Pre - Purchase')) {
        analyseType = "pre_purchase"
      } else if (this.buttonArg.includes('Post - Purchase')) {
        analyseType = "post_purchase"
      } else if (this.buttonArg.includes('Comparision')) {
        analyseType = "comparison"
      } else if (this.buttonArg.includes('Analyze Whole keyword report')) {
        analyseType = "all"
      }
      payloadObj = {
        type: analyseType,
        lid: this.keyWordId,
      }
    } else if (!!this.allSelect) {
      payloadObj = {
        type: "all",
        lid: this.keyWordId,
      }
    } else {
      payloadObj = {
        type: "individual",
        lid: this.keyWordId,
        kids: this.checkArr
      }
    }
    if (this.keyWordType === 'list') {
      delete payloadObj.lid
    }
    this.lckrService.analyseDashboardData(this.filterQuery, payloadObj).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      if (!!res && !!res.message && res.message === 'You do not have enough credits') {
        this.loading = false;
        this.toastr.error(res?.message)
        this.backupKeyWordArray = [];
        this.waiting8MinutesBackupArray = [];
        this.keyWordArray = [];
        this.masterSelected = false;
        this.allSelect = false;
        this.isDisable = false;
        this.keyWordData.forEach((e: any) => {
          if (e.isChecked) {
            e.isChecked = false
          }
        })
      }
      if (!!res && !!res.message && res.message === 'Analyzing keywords started') {
        this.toastr.success("Analysis has been started");

        this.keyword_id = res?.keyword_id
        this.keyWordData.forEach((e: any) => {
          e.isChecked = false
        })
        this.masterSelected = false;
        this.allSelect = false;
        this.isAllChecked = false;
        if (this.keyWordType !== "list") {
          this.lckrService.getSocketRes(this.keyWordId).subscribe((res: any) => {
            this.isDisable = false;
            if (!!res && res.length > 0) {
              res.forEach((el: any) => {
                for (let key in el) {
                  if (!this.ids.includes(Number(key))) {
                    this.ids.push(Number(key))
                  }
                }
              })
            } else {
              keyWordArray = [];
              this.checkArr = [];
              this.ids = []
              this.filterQueryBuilder('noLoadArg');
            }
          })
        } else {
          this.paginateData[0].lid.forEach((e: any) => {
            this.lckrService.getSocketRes(e).subscribe((res: any) => {
              this.isDisable = false;
              if (!!res && res.length > 0) {
                res.forEach((el: any) => {
                  for (let key in el) {
                    if (!this.ids.includes(Number(key))) {
                      this.ids.push(Number(key))
                    }
                  }
                })
              } else {
                keyWordArray = [];
                this.checkArr = [];
                this.ids = []
                this.filterQueryBuilder('noLoadArg');
              }
            })
          });
        }
        // if (this.buttonArg.length > 0) {
        // this.filterQueryBuilder();
        // }
        this.buttonArg = [];
        // this.waiting8MinutesArray = [];
      }
    })
  }
  toggleFilter(matMenuArg: string, item: string, event: MatSlideToggleChange) {
    if (this.activateLink !== 'Competition') {
      if (matMenuArg == "Weak Spots" && KeyWord.weakSpotMenuArray.includes(item)) {
        this.weakSpotFilter = [];
        if (event.checked) {
          if (!this.weakSpotFilter.includes(item)) {
            this.weakSpotFilter.push(item);
          }
        }
        else {
          this.weakSpotFilter = this.weakSpotFilter.filter(e => {
            return e !== item;
          })
        }
      }

      else if (matMenuArg == "Forums" && KeyWord.formusMenuArray.includes(item)) {
        if (event.checked) {
          if (!this.forumFilter.includes(item)) {
            this.forumFilter.push("forum");
          }
        }
        else {
          this.forumFilter = [];
        }
      }
      if (matMenuArg == "Intent" && KeyWord.intentMenuArray.includes(item)) {
        if (event.checked) {
          if (!this.intentFilter.includes(item)) {
            this.intentFilter.push(item);
          }
        }
        else {
          this.intentFilter = this.intentFilter.filter(e => {
            return e !== item;
          })
        }
      }
      if (matMenuArg == "Status" && KeyWord.statusMenuArray.includes(item)) {
        this.statusFilter = [];
        if (event.checked) {
          if (!this.statusFilter.includes(item)) {
            this.statusFilter.push(item);
          }
        }
        else {
          this.statusFilter = this.statusFilter.filter(e => {
            return e !== item;
          })
        }
      }
      if (matMenuArg == "SERP Score" && KeyWord.serpScoreMenuArray.includes(item)) {
        if (event.checked) {
          if (!this.serpScoreFilter.includes(item)) {
            this.serpScoreFilter.push(item);
          }
        }
        else {
          this.serpScoreFilter = this.serpScoreFilter.filter(e => {
            return e !== item;
          })
        }
      }
      // this.queryFilterParams = [...this.intentFilter];
      this.filterQueryBuilder('filters');
    }
  }

  countAll() {
    let lengthCounter = this.backupKeyWordData;
    this.allPaginateData = lengthCounter.filter(e => !this.backupHideArr.includes(e.title));
  }
  backupFilterData: any = []
  filterData(filterArg?: string) {
    this.allSelect = false
    this.backupKeyWordData.forEach(e => e.isChecked = false)
    this.backupFilterData = this.backupKeyWordData;
    let filterdData = this.backupKeyWordData;

    this.allLength = this.suggestionPaginateData.length + this.questionsPaginateData.length;
    this.suggestionLength = this.suggestionPaginateData.length;
    this.questionLength = this.questionsPaginateData.length;
    if (this.daLessthan10) {
      filterdData = filterdData.filter(e => {
        return e.HDA !== null && e.HDA <= 10
      })
    }
    if (this.daLessthan20) {
      filterdData = this.backupKeyWordData;
      filterdData = filterdData.filter(e => {
        return e.HDA !== null && e.HDA <= 20
      })
    }
    if ((!!filterArg && filterArg === "SearchFilter") || this.searchText !== "") {
      if (this.activateLink !== "Cluster") {
        if (this.activateLink === 'Hidden') {
          filterdData = filterdData.filter((e: KeywordData | any) => {
            let key = this.searchText.toLowerCase();
            return (e.title.toLowerCase().search(key) >= 0 && this.backupHideArr.includes(e.title));
          });
        } else if (this.activateLink === 'PAA' || this.activateLink === 'Related Searches') {
          filterdData = filterdData.filter((e: KeywordData | any) => {
            let key = this.searchText.toLowerCase();
            return (e.keyWord[0].toLowerCase().search(key) >= 0);
          });
        } else {
          filterdData = filterdData.filter((e: KeywordData | any) => {
            let key = this.searchText.toLowerCase();
            return (e.title.toLowerCase().search(key) >= 0 && !this.backupHideArr.includes(e.title) && e.title.split(" ")[e.title.split(" ").length - 1] !== 'reddit' && e.title.split(" ")[e.title.split(" ").length - 1] !== 'quora');
          });
        }
      } else {
        filterdData = filterdData.filter((e: KeywordData | any) => {
          let key = this.searchText.toLowerCase();
          return (e.HighestVolKey.title.toLowerCase().search(key) >= 0);
        });
      }
    }
    if (this.backupHideArr.length > 0) {
      this.allLength = this.allPaginateData.filter(el => {
        return !this.backupHideArr.includes(el.title);
      }).length;
      this.suggestionLength = this.suggestionPaginateData.filter((el: any) => {
        return !this.backupHideArr.includes(el.title);
      }).length;
      this.questionLength = this.questionsPaginateData.filter((el: any) => {
        return !this.backupHideArr.includes(el.title);
      }).length;
    }
    if (this.hideArray.length > 0) {
      filterdData = filterdData.filter(e => !this.backupHideArr.includes(e.title));
    }
    if (this.exclude_fix_keywords_backup.length != 0) {
      this.exclude_fix_keywords_backup.forEach((v: any) => {
        this.allPaginateData = this?.allPaginateData.filter((el: any) => {
          if (el?.title?.toUpperCase()?.indexOf(v.toUpperCase()) !== -1 || this.backupHideArr.includes(el.title)) {
          } else { return el }
        });
        this.suggestionPaginateData = this?.suggestionPaginateData.filter((el: any) => {
          if (el?.title?.toUpperCase()?.indexOf(v.toUpperCase()) !== -1 || this.backupHideArr.includes(el.title)) {
          } else { return el }
        });
        this.questionsPaginateData = this?.questionsPaginateData.filter((el: any) => {
          if (el?.title?.toUpperCase()?.indexOf(v.toUpperCase()) !== -1 || this.backupHideArr.includes(el.title)) {
          } else { return el }
        });
      })

      this.exclude_fix_keywords_backup.forEach((a: any) => {
        filterdData = filterdData.filter((e: any) => {
          if (e?.title?.toUpperCase()?.indexOf(a.toUpperCase()) !== -1) {
          } else { return e }
        });
      })
      this.backupFilterData = filterdData
      this.allLength = this.allPaginateData.length
      this.suggestionLength = this.suggestionPaginateData.length
      this.questionLength = this.questionsPaginateData.length
    }
    if (this.activateLink === "Hidden") {
      filterdData = this.hideArray;
      this.paginateData = filterdData;
      this.keyWordData = filterdData;
    }
    if (this.volUparrow) {
      if (this.activateLink !== "Cluster") {
        filterdData = filterdData.sort((a: any, b: any) => {
          if (a.vol == undefined) {
            return 1
          } else if (b.vol == undefined) {
            return -1;
          } else {
            return a.vol - b.vol;
          }
        })
      } else {
        filterdData = filterdData.sort((a: any, b: any) => {
          if (a.clusterVol == undefined) {
            return 1
          } else if (b.clusterVol == undefined) {
            return -1;
          } else {
            return a.clusterVol - b.clusterVol;
          }
        })
      }
      this.volDownarrow = false;
      this.volUparrow = true;
    } else if (this.volDownarrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.vol == undefined) {
          return -1
        } else if (a.vol == undefined) {
          return 1;
        } else {
          return b.vol - a.vol;
        }
      })
      this.volDownarrow = true;
      this.volUparrow = false;
    } else if (this.serpUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1;
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.serpDownArrow = false;
      this.serpUpArrow = true;
    } else if (this.serpDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1;
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.serpDownArrow = true;
      this.serpUpArrow = false;
    } else if (this.weakSpotUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.weakSpotDownArrow = false;
      this.weakSpotUpArrow = true;
    } else if (this.weakSpotDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.weakSpotDownArrow = true;
      this.weakSpotUpArrow = false;
    } else if (this.cpcUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.cpc == undefined) {
          return 1
        } else if (b.cpc == undefined) {
          return -1;
        } else {
          return a?.cpc?.value - b?.cpc?.value;
        }
      })
      this.cpcUpArrow = true;
      this.cpcDownArrow = false;
    } else if (this.cpcDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.cpc == undefined) {
          return -1
        } else if (a.cpc == undefined) {
          return 1;
        } else {
          return b?.cpc?.value - a?.cpc?.value;
        }
      })
      this.cpcDownArrow = true;
      this.cpcUpArrow = false;
    } else if (this.ldaUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.LDA == undefined) {
          return 1
        } else if (b.LDA == undefined) {
          return -1;
        } else {
          return a.LDA - b.LDA;
        }
      })
      this.ldaUpArrow = true;
      this.ldaDownArrow = false;
    } else if (this.ldaDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.LDA == undefined) {
          return -1
        } else if (a.LDA == undefined) {
          return 1;
        } else {
          return b.LDA - a.LDA;
        }
      })
      this.ldaDownArrow = true;
      this.ldaUpArrow = false;
    } else if (this.totalKeywordUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.totalCount == undefined) {
          return 1
        } else if (b.totalCount == undefined) {
          return -1;
        } else {
          return a.totalCount - b.totalCount;
        }
      })
      this.totalKeywordUpArrow = true;
      this.totalKeywordDownArrow = false;
    } else if (this.totalKeywordDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.totalCount == undefined) {
          return -1
        } else if (a.totalCount == undefined) {
          return 1;
        } else {
          return b.totalCount - a.totalCount;
        }
      })
      this.totalKeywordDownArrow = true;
      this.totalKeywordUpArrow = false;
    } else if (this.weakKeywordUpArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (a.clusterWeakSpotCount == undefined) {
          return 1
        } else if (b.clusterWeakSpotCount == undefined) {
          return -1;
        } else {
          return a.clusterWeakSpotCount - b.clusterWeakSpotCount;
        }
      })
      this.weakKeywordUpArrow = true;
      this.weakKeywordDownArrow = false;
    } else if (this.weakKeywordDownArrow) {
      filterdData = filterdData.sort((a: any, b: any) => {
        if (b.clusterWeakSpotCount == undefined) {
          return -1
        } else if (a.clusterWeakSpotCount == undefined) {
          return 1;
        } else {
          return b.clusterWeakSpotCount - a.clusterWeakSpotCount;
        }
      })
      this.weakKeywordDownArrow = true;
      this.weakKeywordUpArrow = false;
    }

    if (this.topicFilter.length > 0) {
      this.topicFilter.forEach((element) => {
        filterdData = filterdData.filter((el: any) => {
          return (el.title.includes(element))
        })
      })
    }
    let fixAry: any = []
    if (this.fixIncludeFixFilter.length != 0) {
      filterdData = []
      this.fixIncludeFixFilter.forEach((element: any) => {
        fixAry = this.backupFilterData.filter((el: any) => {
          return (el.title == element)
        })
        filterdData = filterdData.concat(fixAry)
      })
    }
    let ary: any = []
    if (this.fixIncludeAnyFilter.length != 0) {
      filterdData = []
      this.fixIncludeAnyFilter.forEach((element: any) => {
        ary = this.backupFilterData.filter((el: any) => {
          return (el.title.includes(element))
        })
        filterdData = filterdData.concat(ary)
      })
    }
    this.paginateData = filterdData;
    this.keyWordData = filterdData;
    this.exportData = filterdData;
    this.onTableDataChange();
    this.loading = false
  }
  success(arg: string) {
    if (arg === 'cpc') {
      if (Number(this.cpcFilter.min) || Number(this.cpcFilter.max) > Number(this.cpcFilter.min)) {
        (document.getElementById('cpcApply') as HTMLButtonElement).disabled = false;
      } else if ((!this.cpcFilter.min) || (this.cpcFilter.max && !this.cpcFilter.min)) {
        (document.getElementById('cpcApply') as HTMLButtonElement).disabled = true;
      }

    }
    if (arg === 'vol') {
      if (Number(this.volFilter.min) || (Number(this.volFilter.max) > Number(this.volFilter.min))) {
        (document.getElementById('volApply') as HTMLButtonElement).disabled = false;
      } else if ((!this.volFilter.min) || (this.volFilter.max && !this.volFilter.min)) {
        (document.getElementById('volApply') as HTMLButtonElement).disabled = true;
      }
    }
  }

  downloadFile() {
    let paa: any = []
    let relatedSearch: any = []
    let compitater: any = []
    // let selectedData: any = [];
    this.paaPaginateData
    this.relatedSearchedPaginateData
    this.competitionPaginateData
    this.lckrKeyWordData

    this.keyWordData.forEach(e => {
      if (e.isChecked) {
        this.exportSelectedData.push(e);

        this.lckrKeyWordData.forEach((l: any) => {
          if (!!l.json_data?.data?.paa) {
            l.json_data.data.paa.forEach((el: any) => {
              if (el[e.title]) {
                paa.push(el)
              }
            });
          }
          if (!!l.json_data?.data?.analysis) {
            if (l.json_data.data.analysis[e.title]) {
              let Obj: any = {}
              let key = e.title
              Obj[key] = l.json_data.data.analysis[e.title]
              compitater.push(Obj)
            }
          }
          if (!!l.json_data?.data?.related) {
            l.json_data.data.related.forEach((el: any) => {
              if (el[e.title]) {
                relatedSearch.push(el)
              }
            });
          }

        })
      }
    });


    this.toastr.success("Excel download process is started");
    let obj = {
      paa: paa,
      relatedSearch: relatedSearch,
      compitater: compitater,
      keyWordName: this.keyWordName ? this.keyWordName : "excel",
      selectedExcel: true,
      activateLink: this.activateLink,
      exportSelectedData: this.exportSelectedData
    }
    this.keyWordData.forEach(e => {
      if (e.isChecked) { e.isChecked = false }
    })
    this.editorService.exportSelectedExcel(obj).pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      try {
        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_self");
        }
        dwldLink.setAttribute("href", `${environment.apiUrl}TempExcel/strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        // dwldLink.setAttribute("href", `http://localhost:4000/TempExcel/strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        dwldLink.setAttribute("download", `strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);


        // window.open(`${environment.apiUrl}/TempExcel/${this.keyWordName}.xlsx`, "_blank");
        // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })

    this.exportSelectedData = [];
    this.masterSelected = false;
    this.allSelect = false;
    this.keyWordData.forEach(e => {
      e.isChecked = false;
    });
    this.isAllChecked = false;
  }

  downloadAllData() {
    // let obj = {
    //   exportData: this.exportData.filter((v: any) => { v.isChecked }),
    //   keyWordData: this.keyWordData,
    //   lckrKeyWordData: this.lckrKeyWordData,
    //   backupHideArr: this.backupHideArr,
    //   hideArray: this.hideArray,
    //   keyWordName: this.keyWordName ? this.keyWordName : "excel",
    //   selectedExcel: false
    // } 
    let obj
    if (!!this.keyWordType && this.keyWordType === 'list') {
      obj = {
        "report_type": "listkeyword",
        "lid": this.keyWordId
      }
    } else {
      obj = {
        lid: this.keyWordId
      }
    }
    this.lckrService.downloadExcel(obj).pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      if(res && res.message && res.message==="excel is running"){
        this.toastr.success("Excel download process is started");
        this.excelLoader = true
      }
      // try {

      //   let dwldLink = document.createElement("a");
      //   let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
      //   if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      //     dwldLink.setAttribute("target", "_self");
      //   }
      //   dwldLink.setAttribute("href", res.path);
      //   dwldLink.setAttribute("download", res.path);
      //   dwldLink.style.visibility = "hidden";
      //   document.body.appendChild(dwldLink);
      //   dwldLink.click();
      //   document.body.removeChild(dwldLink);

      //   // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
      //   this.excelLoader = false
      // } catch (error: any) {
      //   this.toastr.error(error.message)
      // }
    })

  }
  downloadSeprateDataExcel() {
    this.keyWordData
    this.toastr.success(`${this.activateLink} Excel download process is started`);
    this.separateExcelLoader = true
    let obj = {
      keyWordData: this.keyWordData.filter((v: any) => v.isChecked),
      keyWordName: this.keyWordName ? this.keyWordName : "excel",
      activateLink: this.activateLink,
      lckrKeyWordData: this.lckrKeyWordData
    }
    if (obj.keyWordData.length == 0) {
      obj.keyWordData = this.keyWordData
    }
    this.keyWordData.forEach(e => {
      if (e.isChecked) { e.isChecked = false }
    })
    this.editorService.exportSeprateDataExcel(obj).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      try {

        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_self");
        }
        dwldLink.setAttribute("href", `${environment.apiUrl}TempExcel/strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        // dwldLink.setAttribute("href", `http://localhost:4000/TempExcel/${obj.keyWordName}.xlsx`);
        dwldLink.setAttribute("download", `strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
        this.separateExcelLoader = false;
        // window.open(`http://localhost:4000/TempExcel/${this.keyWordName}.xlsx`, "_blank");
        this.excelLoader = false
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })

  }

  sortTable(arg: string) {
    this.sortArray = [];
    if (arg === 'vol') {
      if (!this.volUparrow && !this.volDownarrow) {
        this.volUparrow = true;
      } else if (!!this.volUparrow) {
        this.volUparrow = false;
        this.volDownarrow = true;
      } else if (!!this.volDownarrow) {
        this.volUparrow = false;
        this.volDownarrow = false;
      }
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.volUparrow) {
        if (this.activateLink === 'clusters') {
          this.sortArray.push('total_volume')
        } else {
          this.sortArray.push('volume')
        }
        // this.volDownarrow = false
        // this.filterData();
      } else if (this.volDownarrow) {
        if (this.activateLink === 'clusters') {
          this.sortArray.push('-total_volume')
        } else {
          this.sortArray.push('-volume')
        }        // this.volUparrow = false;
        // this.filterData();
      }
    } else if (arg === 'cpc') {
      if (!this.cpcUpArrow && !this.cpcDownArrow) {
        this.cpcUpArrow = true;
      } else if (!!this.cpcUpArrow) {
        this.cpcUpArrow = false;
        this.cpcDownArrow = true;
      } else if (!!this.cpcDownArrow) {
        this.cpcUpArrow = false;
        this.cpcDownArrow = false;
      }
      // this.cpcUpArrow = !this.cpcUpArrow;
      // this.cpcUpArrow == true ? this.cpcUpArrow = true : this.cpcDownArrow = true;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.cpcUpArrow) {
        this.sortArray.push('cpc')
        // this.filterData();
      } else if (this.cpcDownArrow) {
        this.sortArray.push('-cpc')
        // this.filterData();
      }
    } else if (arg === 'lda') {
      if (!this.ldaUpArrow && !this.ldaDownArrow) {
        this.ldaUpArrow = true;
      } else if (!!this.ldaUpArrow) {
        this.ldaUpArrow = false;
        this.ldaDownArrow = true;
      } else if (!!this.ldaDownArrow) {
        this.ldaUpArrow = false;
        this.ldaDownArrow = false;
      }
      // this.ldaUpArrow = !this.ldaUpArrow;
      // this.ldaUpArrow == true ? this.ldaUpArrow = true : this.ldaDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.ldaUpArrow) {
        this.sortArray.push('lda')
        // this.filterData();
      } else if (this.ldaDownArrow) {
        this.sortArray.push('-lda')
        // this.filterData();
      }
    } else if (arg === 'totalKeyword') {
      if (!this.totalKeywordUpArrow && !this.totalKeywordDownArrow) {
        this.totalKeywordUpArrow = true;
      } else if (!!this.totalKeywordUpArrow) {
        this.totalKeywordUpArrow = false;
        this.totalKeywordDownArrow = true;
      } else if (!!this.totalKeywordDownArrow) {
        this.totalKeywordUpArrow = false;
        this.totalKeywordDownArrow = false;
      }
      // this.totalKeywordUpArrow = !this.totalKeywordUpArrow;
      // this.totalKeywordUpArrow == true ? this.totalKeywordUpArrow = true : this.totalKeywordDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.totalKeywordUpArrow) {
        // this.filterData();
        this.sortArray.push('total_keywords')

      } else if (this.totalKeywordDownArrow) {
        // this.filterData();
        this.sortArray.push('-total_keywords')

      }
    } else if (arg === 'serp') {
      if (!this.serpUpArrow && !this.serpDownArrow) {
        this.serpUpArrow = true;
      } else if (!!this.serpUpArrow) {
        this.serpUpArrow = false;
        this.serpDownArrow = true;
      } else if (!!this.serpDownArrow) {
        this.serpUpArrow = false;
        this.serpDownArrow = false;
      }
      // this.serpUpArrow = !this.serpUpArrow;
      // this.serpUpArrow == true ? this.serpUpArrow = true : this.serpDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.weakSpotUpArrow = false;
      this.weakSpotDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.serpUpArrow) {
        this.sortArray.push('serp_score_count')
        // this.filterData();
      } else if (this.serpDownArrow) {
        this.sortArray.push('-serp_score_count')
        // this.filterData();
      }
    } else if (arg === "weakSpot") {
      if (!this.weakSpotUpArrow && !this.weakSpotDownArrow) {
        this.weakSpotUpArrow = true;
      } else if (!!this.weakSpotUpArrow) {
        this.weakSpotUpArrow = false;
        this.weakSpotDownArrow = true;
      } else if (!!this.weakSpotDownArrow) {
        this.weakSpotUpArrow = false;
        this.weakSpotDownArrow = false;
      }
      // this.weakSpotUpArrow = !this.weakSpotUpArrow;
      // this.weakSpotUpArrow == true ? this.weakSpotUpArrow = true : this.weakSpotDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      this.weakKeywordUpArrow = false
      this.weakKeywordDownArrow = false
      if (this.weakSpotUpArrow) {
        this.sortArray.push('serp_score_count')
        // this.filterData();
      } else if (this.weakSpotDownArrow) {
        this.sortArray.push('-serp_score_count')
        // this.filterData();
      }
    } else if (arg === "weakKeyword") {
      if (!this.weakKeywordUpArrow && !this.weakKeywordDownArrow) {
        this.weakKeywordUpArrow = true;
      } else if (!!this.weakKeywordUpArrow) {
        this.weakKeywordUpArrow = false;
        this.weakKeywordDownArrow = true;
      } else if (!!this.weakKeywordDownArrow) {
        this.weakKeywordUpArrow = false;
        this.weakKeywordDownArrow = false;
      }
      // this.weakKeywordUpArrow = !this.weakKeywordUpArrow;
      // this.weakKeywordUpArrow == true ? this.weakKeywordUpArrow = true : this.weakKeywordDownArrow = true;
      this.volUparrow = false;
      this.volDownarrow = false;
      this.serpUpArrow = false;
      this.serpDownArrow = false;
      this.cpcUpArrow = false;
      this.cpcDownArrow = false;
      this.ldaUpArrow = false;
      this.ldaDownArrow = false;
      this.totalKeywordUpArrow = false
      this.totalKeywordDownArrow = false
      if (this.weakKeywordUpArrow) {
        // this.filterData();
        this.sortArray.push('total_weak_spots')
      } else if (this.weakKeywordDownArrow) {
        // this.filterData();
        this.sortArray.push('-total_weak_spots')
      }
    }
    this.filterQueryBuilder();
  }
  sortCluster(arg: string, index: number) {
    if (arg === 'vol') {
      this.clusteredData[index].volUparrow = !this.clusteredData[index].volUparrow;
      this.clusteredData[index].volUparrow == true ? this.clusteredData[index].volUparrow = true : this.clusteredData[index].volDownarrow = true;
      this.clusteredData[index].serpUpArrow = false;
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].weakSpotUpArrow = false;
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].cpcUparrow = false;
      this.clusteredData[index].cpcDownarrow = false;
      if (this.clusteredData[index].volUparrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].volDownarrow) {
        this.sortClusterData(index);
      }
    } else if (arg === 'cpc') {
      this.clusteredData[index].cpcUparrow = !this.clusteredData[index].cpcUparrow;
      this.clusteredData[index].cpcUparrow == true ? this.clusteredData[index].cpcUparrow = true : this.clusteredData[index].cpcDownarrow = true;
      this.clusteredData[index].serpUpArrow = false;
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].weakSpotUpArrow = false;
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].volUparrow = false;
      this.clusteredData[index].volDownarrow = false;
      if (this.clusteredData[index].cpcUparrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].cpcDownarrow) {
        this.sortClusterData(index);
      }
    } else if (arg === 'serp') {
      this.clusteredData[index].serpUpArrow = !this.clusteredData[index].serpUpArrow;
      this.clusteredData[index].serpUpArrow == true ? this.clusteredData[index].serpUpArrow = true : this.clusteredData[index].serpDownArrow = true;
      this.clusteredData[index].volUparrow = false;
      this.clusteredData[index].volDownarrow = false;
      this.clusteredData[index].weakSpotUpArrow = false;
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].cpcUparrow = false;
      this.clusteredData[index].cpcDownarrow = false;
      if (this.clusteredData[index].serpUpArrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].serpDownArrow) {
        this.sortClusterData(index);
      }
    } else if (arg === "weakSpot") {
      this.clusteredData[index].weakSpotUpArrow = !this.clusteredData[index].weakSpotUpArrow;
      this.clusteredData[index].weakSpotUpArrow == true ? this.clusteredData[index].weakSpotUpArrow = true : this.clusteredData[index].weakSpotDownArrow = true;
      this.clusteredData[index].volUparrow = false;
      this.clusteredData[index].volDownarrow = false;
      this.clusteredData[index].serpUpArrow = false;
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].cpcUparrow = false;
      this.clusteredData[index].cpcDownarrow = false;
      if (this.clusteredData[index].weakSpotUpArrow) {
        this.sortClusterData(index);
      } else if (this.clusteredData[index].weakSpotDownArrow) {
        this.sortClusterData(index);
      }
    }
  }
  sortClusterData(index: number) {
    let filterdData = this.clusteredData[index];
    if (this.clusteredData[index].volUparrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.vol == undefined) {
          return 1
        } else if (b.vol == undefined) {
          return -1;
        } else {
          return a.vol - b.vol;
        }
      })
      this.clusteredData[index].volDownarrow = false;
      this.clusteredData[index].volUparrow = true;
    } else if (this.clusteredData[index].volDownarrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.vol == undefined) {
          return -1
        } else if (a.vol == undefined) {
          return 1;
        } else {
          return b.vol - a.vol;
        }
      })
      this.clusteredData[index].volDownarrow = true;
      this.clusteredData[index].volUparrow = false;
      // this.onTableDataChange()
    } else if (this.clusteredData[index].cpcUparrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.cpc == undefined) {
          return 1
        } else if (b.cpc == undefined) {
          return -1;
        } else {
          return a?.cpc?.value - b?.cpc?.value;
        }
      })
      this.clusteredData[index].cpcDownarrow = false;
      this.clusteredData[index].cpcUparrow = true;
    } else if (this.clusteredData[index].cpcDownarrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.cpc == undefined) {
          return -1
        } else if (a.cpc == undefined) {
          return 1;
        } else {
          return b?.cpc?.value - a?.cpc?.value;
        }
      })
      this.clusteredData[index].cpcDownarrow = true;
      this.clusteredData[index].cpcUparrow = false;
      // this.onTableDataChange()
    } else if (this.clusteredData[index].serpUpArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1;
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.clusteredData[index].serpDownArrow = false;
      this.clusteredData[index].serpUpArrow = true;
      // this.onTableDataChange();
    } else if (this.clusteredData[index].serpDownArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1;
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.clusteredData[index].serpDownArrow = true;
      this.clusteredData[index].serpUpArrow = false;
      // this.onTableDataChange()
    } else if (this.clusteredData[index].weakSpotUpArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (a.weakSpotCount == undefined) {
          return 1
        } else if (b.weakSpotCount == undefined) {
          return -1;
        } else {
          return a.weakSpotCount - b.weakSpotCount;
        }
      })
      this.clusteredData[index].weakSpotDownArrow = false;
      this.clusteredData[index].weakSpotUpArrow = true;
    } else if (this.clusteredData[index].weakSpotDownArrow) {
      filterdData = filterdData?.cluster?.sort((a: any, b: any) => {
        if (b.weakSpotCount == undefined) {
          return -1
        } else if (a.weakSpotCount == undefined) {
          return 1;
        } else {
          return b.weakSpotCount - a.weakSpotCount;
        }
      })
      this.clusteredData[index].weakSpotDownArrow = true;
      this.clusteredData[index].weakSpotUpArrow = false;
      // this.onTableDataChange()
    }
    this.clusteredData[index].cluster = filterdData;
    this.paginateData = this.clusteredData;
    this.getClusterData(index);
  }
  handleHide(isHide: boolean) {
    let tempAry: any = []
    if (this.activateLink === 'all' || this.activateLink === 'suggestion' || this.activateLink === 'question') {
      if (isHide) {
        this.keyWordData = this.keyWordData.filter((e, index) => {
          if (e.isChecked) {
            // if (this.backupHideArr.length == 0 || !this.backupHideArr.includes(e.title)) {
            // this.hideArray.push(e);
            // this.hiddenDataBackupArr.push(e);
            // this.backupHideArr.push(e.title);
            tempAry.push(e.id);
            // this.hideKeywordAry?.push(e.title)
            // }
          } else {
            return e;
          }
        });
        this.lckrService.handleHideUnhide({
          "kids": tempAry,
          "type": "hide",
        }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
          if (res) {
            this.filterQueryBuilder();
            this.getTabsCount();
          }
        })
      }
      this.hiddenDataLength = this.hideArray.length;
      this.masterSelected = false;
      this.allSelect = false;
      this.isAllChecked = false;
      // this.changePaginateData('Hidden');
      // this.onTableDataChange();
    } else if (this.activateLink === 'hidden') {
      let tempAry: any = []
      if (!isHide) {
        this.hideArray = this.keyWordData.filter(e => { return !!e.isChecked });
        this.backupHideArr = [];
        this.hiddenDataBackupArr = [];
        this.hideKeywordAry = [];
        this.hideArray.forEach((e: any) => {
          tempAry.push(e.id)
        })
        this.lckrService.handleHideUnhide({
          "kids": tempAry,
          "type": "unhide",
        }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
          if (res) {
            this.getTabsCount()
            this.filterQueryBuilder();
          }
        })
        this.hiddenDataLength = this.hideArray.length;
        this.masterSelected = false;
        this.allSelect = false;
        this.isAllChecked = false;
      }

    }
  }
  checkDomainlowdaStatus(doamin: any) {
    let flag = false;
    if (doamin && this.lckrKeyWordData?.length > 0) {
      for (let j = 0; j < this.lckrKeyWordData?.length; j++) {
        if (this.lckrKeyWordData[j]?.json_data != undefined) {
          let data = this.lckrKeyWordData[j]?.keyword;
          if (typeof data == "object") {
            let findIndex = data.findIndex((element: any, i: any) =>
              this.lckrKeyWordData[j]?.json_data?.data?.analysis[data[i]]?.some((item: any) => item?.lowda == true && doamin == item?.domain))
            if (findIndex !== -1) {
              return true;
            }
          } else {
            return flag;
          }
        }
      }
      return flag;
    }
    return flag
  }

  linkCopy() {
    var dummy = document.createElement('input');
    //let text = window.location.href;
    // let url = `${window.location.protocol + "//" + window.location.host}/lckr/dashboard/${this.keyWordId}?uid=${this.uid}&theme=${this.theme}&type=${this.keyWordType}`
    let url = `${window.location.protocol + "//" + window.location.host}/lckr/reports/dashboard2/${this.keyWordId}?${this.filterQuery}`
    document.body.appendChild(dummy);
    dummy.value = url;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    this.toastr.success("Link Copied to clipboard")
  }
  getCredit() {
    let analysisData = this.keyWordData;
    this.highintentLength = analysisData.filter((el: any) => {
      return (el.title.includes('best') || el.title.includes('review') || el.title.includes('free'))
    }).length;
    this.prePurchaseLength = analysisData.filter((el: any) => {
      return (el.title.includes('best') || el.title.includes('review') || el.title.includes('buy') || el.title.includes('discounts'))
    }).length;
    this.postPurchaseLength = analysisData.filter((el: any) => {
      return (el.title.includes('problem') || el.title.includes('warrenty') || el.title.includes('broken') || el.title.includes('clean'))
    }).length;
    this.comparisionLength = analysisData.filter((el: any) => {
      return (el.title.includes('vs') || el.title.includes('compare') || el.title.includes('comparision') || el.title.includes('alternative') || el.title.includes('alternatives') || el.title.includes('difference') || el.title.includes('compared to'))
    }).length;
    this.wholeKeywordReportLength = analysisData.length;
  }
  analyseByIntent(arg: string) {
    this.buttonArg.push(arg);
    this.dialog.closeAll();
    this.performSerpExtract();
    this.toastr.success(`Started Analyzing ${arg} Keywords. Use Filters to find them out in a Report.`)
  }

  openDialog(data: string) {
    this.confirmationPopupData = data
    this.dialog.open(this.confirmationDialog, {
      width: '40%',
      panelClass: !this.theme ? 'dark-modal-mat' : ''
    });
  }
  cancelDialog() {
    this.dialog.closeAll();
  }
  jumpToPage() {
    this.page = this.jumpToPageCount;
    this.filterQueryBuilder();
  }
  collapseToggle(index: number) {
    this.paginateData[index].isShow = !this.paginateData[index].isShow;
    // if (this.paginateData[index].isShow) {
    //   this.isClicked = true;
    //   this.clusteredData[index].volUparrow = false;
    //   this.clusteredData[index].volDownarrow = false;
    //   this.clusteredData[index].serpUpArrow = false;
    //   this.clusteredData[index].serpDownArrow = false;
    //   this.clusteredData[index].weakSpotUpArrow = false;
    //   this.clusteredData[index].weakSpotDownArrow = false;
    //   // this.getSubCluster(index);
    // }
  }

  getClusterDataFromDatabase() {
    this.editorService.getSavedClusterData({ "lid": this.keyWordId }).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      try {
        this.loading = false
        if (typeof (res?.cluster_data?.cluster_data) != 'object') {
          this.SERPSimilarity = res?.cluster_data?.SERPSimilarity
          let ary: any = JSON.parse(res?.cluster_data?.cluster_data)
          this.clusteredData = ary;
          this.changePaginateData();
          this.clusterLength = this.clusteredData.length
        }
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })
  }

  exportClusterExcel() {
    this.toastr.success("Excel download process is started");
    let clusterAry: any = []
    let ary = this.clusteredData.forEach((v: any) => {
      if (v.cluster.length != 0) {
        let i = 0
        v.cluster.forEach((a: any) => {
          let d = (a?.cpc?.value == "0" || a?.cpc?.value == null || a?.cpc?.value == undefined) ? "-" : a?.cpc?.currency + a?.cpc?.value;
          let Obj = {
            "main_keyword": i == 0 ? v?.title : "",
            "totalKeyword": i == 0 ? v?.totalCount : "",
            "weakKeyword": i == 0 ? v?.clusterWeakSpotCount : "",
            "totalClusterVol": i == 0 ? v?.clusterVol : "",
            "title": a?.title,
            "vol": a?.vol ? a?.vol : '<10',
            "cpc": d,
          }
          clusterAry.push(Obj)
          i++
        })
      }
    })
    let obj: any = {
      "clusteredData": clusterAry,
      "activateLink": this.activateLink,
      "keyWordName": this.keyWordName ? this.keyWordName : "excel"
    }
    this.clusterExcelLoader = true
    this.editorService.exportClusterExcel(obj).pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      try {
        this.clusterExcelLoader = false
        let dwldLink = document.createElement("a");
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_self");
        }

        dwldLink.setAttribute("href", `${environment.apiUrl}TempExcel/strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        // dwldLink.setAttribute("href", `http://localhost:4000/TempExcel/${obj.keyWordName}.xlsx`);
        dwldLink.setAttribute("download", `strell_${obj.keyWordName}_${new Date().toISOString().split('T')[0]}.xlsx`);
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
      } catch (error: any) {
        this.toastr.error(error.message)
      }
    })
  }

  getClusterData(index: number) {
    let clusters: any = this.paginateData;
    this.paginateData[index].paginateData = clusters[index].cluster
      .slice((this.paginateData[index].page - 1) * this.tableSize, (this.paginateData[index].page - 1) * this.tableSize + this.tableSize);
    this.loading = false;
  }
  setActive(btnType: string) {
    if (btnType === "lessThan10") {
      this.daLessthan10 = !this.daLessthan10;
    } else {
      this.daLessthan20 = !this.daLessthan20;
    }
    this.filterQueryBuilder('filters')
  }
  onSettingsAdd(eventData: any) {
    this.loading = true;
    this.lckrService.postGlobalSettings({
      "lid": this.keyWordId,
      "max_da": eventData.maxDa,
      "highlighted_domains": eventData.customDomain,
      "mysite_domains": eventData.mySites,
      "main_type": "individual_lckr_settings",
      "type": "save_local_settings",
    }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (!!res && !res.error) {
        this.settingsData.type = "local"
        this.settingsData.theme = this.theme
        this.settingsData = eventData;
        this.loading = false;
      }
    })
  }
  tabChanged(e: any) {
    this.includeKeyword = '';
  }

  addExcludeKeywords(type?: any) {
    if (this.include_any_keywords.some((e: any) => e.title === this.excludeKeyword)) {
      this.toastr.error("Keyword already exist in include filter.")
    } else {
      let keyword_ary: any = []
      this.exclude_any_keywords.forEach((e: any) => {
        keyword_ary.push(e.text);
      })
      if (this.excludeKeyword !== '') {
        if (!keyword_ary.includes(this.excludeKeyword)) {
          keyword_ary.push(this.excludeKeyword)
          this.exclude_fix_keywords_backup.push(this.excludeKeyword);
          this.lckrService.saveIncludeExclude(this.keyWordId, {
            "type": "E",
            "kw_list": keyword_ary,
          }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
            if (!!res) {
              this.toastr.info("keywords excludes successfully")
              keyword_ary = [];
              this.getExcludes();
              this.filterQueryBuilder()
              this.excludeKeyword = ''
            }
          })
        } else {
          this.toastr.error("keyword already added in list")
        }
      }
    }

  }
  removeExcludeKeyword(keyword: any) {
    this.exclude_fix_keywords_backup = this.exclude_fix_keywords_backup.filter((v: any) => v != keyword)
    this.exclude_any_keywords = this.exclude_any_keywords.filter((v: any) => v.text != keyword);
    this.fixExcludeAnyFilter = this.fixExcludeAnyFilter.filter((v: any) => v != keyword)
    // this.filterQueryBuilder();
    let arr: any = []
    this.exclude_any_keywords.forEach((el: any) => {
      arr.push(el.text)
    })
    this.lckrService.saveIncludeExclude(this.keyWordId, {
      "type": "E",
      "kw_list": arr,
    }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (!!res) {
        this.toastr.info("keywords excludes successfully")
        arr = [];
        this.getExcludes();
        this.filterQueryBuilder()
        this.excludeKeyword = ''
      }
    })
  }

  removeIncludeKeyword(keyword: any, type: any) {
    let ary: any = []
    if (type == "Fix") {
      this.include_fix_keywords = this.include_fix_keywords.filter((v: any) => {
        if (v.title != keyword) {
          ary.push(v.title)
          return v
        } else {

        }
      })
      this.loading = true
      this.editorService.removeIncludeKeywords({
        "lid": this.keyWordId,
        "type": "Fix",
        "keywords": ary,
      }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
        if (!!res) {
          ary = [];
          this.loading = false
          this.filterQueryBuilder();

          this.toastr.info("included keyword remove successfully")
        }
      })
    } else {
      this.include_any_keywords = this.include_any_keywords.filter((v: any) => {
        if (v.title != keyword) {
          ary.push(v.title)
          return v
        }
      })
      this.fixIncludeAnyFilter = this.fixIncludeAnyFilter.filter((v: any) => v != keyword)
      this.filterQueryBuilder();
    }
  }

  addIncludeKeyword(type: any) {
    if (this.exclude_fix_keywords_backup.includes(this.includeKeyword)) {
      this.toastr.error("Keyword already exist in exclude filter.")
    } else {
      let keyword_ary: any = []
      if (type == "Fix") {
        keyword_ary.push(this.includeKeyword)
        this.include_fix_keywords.push({ 'selected': false, 'title': this.includeKeyword })
      } else {
        keyword_ary.push(this.includeKeyword)
        this.include_any_keywords.push({ 'selected': false, 'title': this.includeKeyword })
      }
      this.loading = true
      this.lckrService.saveIncludeExclude(this.keyWordId, {
        "type": "I",
        "kw_list": keyword_ary,
      }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
        if (!!res) {
          this.loading = false
          this.toastr.info("keywords Include successfully")
          keyword_ary = []
          this.includeKeyword = '';
          this.filterQueryBuilder()
        }
      })
    }


  }

  fixIncludeFixFilter: any = []
  fixIncludeAnyFilter: any = []
  fixExncludeFixFilter: any = []
  fixExcludeAnyFilter: any = []
  selectAnyChip(keyword: any, type: string) {
    if (type === 'include') {
      this.include_any_keywords.forEach((element: any) => {
        if (element.title == keyword.title) {
          element.selected = !element.selected;

          if (element.selected == true) {
            this.fixIncludeAnyFilter.push(element.title);
          }
          else {
            this.fixIncludeAnyFilter = this.fixIncludeAnyFilter.filter((e: any) => {
              return e !== element.title;
            })
          }
        }
      });
      if (this.fixIncludeAnyFilter.length > 0) {
        this.filterQueryBuilder('filters');
      } else {
        this.filterQueryBuilder();
      }
    } else {
      this.exclude_any_keywords.forEach((element: any) => {
        if (element.title == keyword.title) {
          element.selected = !element.selected;

          if (element.selected == true) {
            this.fixExcludeAnyFilter.push(element.title);
          }
          else {
            this.fixExcludeAnyFilter = this.fixExcludeAnyFilter.filter((e: any) => {
              return e !== element.title;
            })
          }
        }
      });
      if (this.fixExcludeAnyFilter.length > 0) {
        this.filterQueryBuilder('filters');
      } else {
        this.filterQueryBuilder();
      }
    }

  }

  getGlobalSettingData() {
    this.loading = true
    this.editorService.getGlobalSettingData({
      "uid": this.uid,
    }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res && res.globalSetting.length != 0) {
        let data = res.globalSetting[0]
        // this.loading = false
        this.settingsData.maxDa = data.max_da === 0 ? 30 : data.max_da;
        this.settingsData.customDomain = data.highlight_domain != "" ? JSON.parse(data.highlight_domain?.replace(/'/g, '"')) : []
        this.settingsData.mySites = data.my_site != "" ? JSON.parse(data.my_site?.replace(/'/g, '"')) : []
        this.settingsData.type = "global"
        this.settingsData.theme = this.theme
        this.editorService.sendLocalSettingData(this.settingsData)
      }
    })
  }

  addOneListName() {
    let data = {
      "name": this.listName
    }
    this.loading = true
    this.lckrService.addList(data).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      try {
        if (res) {
          this.saveListData(res.id)
          this.getListNames()
          // this.modal.dismissAll();
          this.toastr.success("list add successfully")
          // this.keyWordData.forEach((v:any)=>{if(v.isChecked){v.isChecked = false}} )
          this.loading = false;
          this.modal.dismissAll();
        }
      } catch (error) {

      }
    })

  }

  getListNames() {
    this.lckrService.getList().pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      try {
        if (res.results != 0) {
          let ary: any = []
          this.Lists = res.results
          for (let i = 0; i < res.results.length; i++) {
            let x = res.results[i].name
            ary = ary.concat(x);
          }
          this.saveListKeywordAry = ary;
          // this.saveListKeywordAry = res?.listName[0]?.saved_list_data_keyword?.keyword_data ? JSON.parse(res?.listName[0]?.saved_list_data_keyword?.keyword_data)  : []
        }
      } catch (error) {

      }
    })
  }
  saveListKeywordAry: any = []
  saveListData(lid: any) {
    let ary = []
    let withOutSerp: any = []
    let allCheckKeyword: any = []
    let keywordAry: any = []
    ary = this.keyWordData.filter((v: any) => v.isChecked)
    let isToast = false;
    ary.forEach(v => {
      // if (this.saveListKeywordAry.includes(v.id)) {
      //   if(!isToast){
      //     this.toastr.error(`Keywords is already added in list`)
      //     isToast = true
      //   }
      //   return
      // }
      keywordAry.push(v.id)
      this.saveListKeywordAry.push(v.id)
      allCheckKeyword.push(v.keyword)
    })
    this.loading = true
    this.lckrService.getListDetails({
      "type": "save_data",
      "lckrlist_id": lid,
      "keyword_ids": this.checkArr
    }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.loading = false;
      ary = [];
      this.checkArr = [];
      this.refresh();
    })

  }

  logOut() {
    Gleap.clearIdentity();
    localStorage.clear()
    sessionStorage.clear()
    this.cookieServ.delete("uid", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("userName", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("email", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("plan", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("first_name", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("last_name", "/", window.location.hostname, true, "None");
    this.router.navigate(['login']);
  }

  deleteListKeyword(keyword: any) {
    if (this.keyWordType == 'list') {
      const Obj = {
        type: "delete_keyword_data",
        lckrlist_id: this.keyWordId,
        uid: this.uid,
        keyword_ids: [keyword]
      }
      this.loading = true
      this.lckrService.getListDetails(Obj).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
        if (res) {
          this.loading = false
          this.getListData()
          this.toastr.success("List keyword deleted successfully.")
          // this.getAllData()
        }
      })

    }
  }
  searchKeyword() {
    if (!!this.searchTimeOutId) {
      clearTimeout(this.searchTimeOutId)
    }
    this.searchTimeOutId = setTimeout(() => {
      this.filterQueryBuilder();
    }, 1000);
  }
  filterQueryBuilder(loadArg?: string) {
    // this.savedIds = [];
    if (!!loadArg && loadArg == "noLoadArg") {
      if (!!this.loading) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    } else {
      this.loading = true;
    }
    if (loadArg === 'filters') {
      this.page = 1;
    }
    if (!!loadArg && loadArg === 'fromSelChange') {
      this.backUptableSize = this.tableSize
    }

    if (this.activateLink == 'clusters') {
      this.tableSize = "10";
    } else {
      this.tableSize = this.backUptableSize
    }
    if (this.keyWordType != "list") {
      this.filterQuery = `page=${this.page}&lid=${this.keyWordId}&page_size=${this.tableSize}`;
      if (this.activateLink == "suggestion" || this.activateLink == "question" || this.activateLink == "hidden") {
        this.filterQuery = this.filterQuery + this.addTabType();
      }
      if (!!this.daLessthan10) {
        this.filterQuery = this.filterQuery + `&da_10=True`
      }
      if (!!this.daLessthan20) {
        this.filterQuery = this.filterQuery + `&da_20=True`
      }
      if (!!this.isVolActive && this.volFilter.min !== '' && this.volFilter.min !== null) {
        this.filterQuery = this.filterQuery + `&volume_min=${Number(this.volFilter.min)}`;
      }
      if (!!this.isVolActive && this.volFilter.max !== '' && this.volFilter.max !== null) {
        this.filterQuery = this.filterQuery + `&volume_max=${Number(this.volFilter.max)}`;
      }
      if (!!this.isCpcActive && this.cpcFilter.min !== '' && this.cpcFilter.min !== null) {
        this.filterQuery = this.filterQuery + `&cpc_min=${Number(this.cpcFilter.min)}`;
      }
      if (!!this.isCpcActive && this.cpcFilter.max !== '' && this.cpcFilter.max !== null) {
        this.filterQuery = this.filterQuery + `&cpc_max=${Number(this.cpcFilter.max)}`;
      }
      if (this.forumFilter.length > 0) {
        this.filterQuery = this.filterQuery + '&forum_top_3=True';
      }
      if (this.weakSpotFilter.length > 0) {
        let weakSpotQuery;
        if (this.weakSpotFilter.includes('At least 1 (in top 10)')) {
          weakSpotQuery = `&weak_spot_top_10=True`
        } else if (this.weakSpotFilter.includes('At least 1 (in top 3)')) {
          weakSpotQuery = `&weak_spot_top_3=True`
        } else if (this.weakSpotFilter.includes('At least 1 (with Low DA)')) {
          weakSpotQuery = `&weak_spot_1=True`
        } else {
          weakSpotQuery = `&no_weak_spot=True`
        }
        this.filterQuery = this.filterQuery + weakSpotQuery;
      }
      if (this.sortArray.length > 0) {
        this.filterQuery = this.filterQuery + `&ordering=${this.sortArray[0]}`
      }
      if (this.intentFilter.length > 0) {
        // let intentQuery;
        if (this.intentFilter.includes('high_intent')) {
          this.filterQuery = this.filterQuery + `&intent=HI`
        }
        if (this.intentFilter.includes('pre_purchase')) {
          this.filterQuery = this.filterQuery + `&intent=PP`
        }
        if (this.intentFilter.includes('post_purchase')) {
          this.filterQuery = this.filterQuery + `&intent=PB`
        }
        if (this.intentFilter.includes('comparison')) {
          this.filterQuery = this.filterQuery + `&intent=C`
        }
        // this.filterQuery = this.filterQuery + intentQuery;
      }
      let arr = [];
      if (this.topicFilter.length > 0) {
        this.topicFilter.forEach(e => {
          arr.push(JSON.stringify(e))
        })
      }
      if (this.searchText !== '') {
        arr.push(JSON.stringify(this.searchText))
      }
      if (this.fixIncludeAnyFilter.length > 0) {
        this.fixIncludeAnyFilter.forEach((e: any) => {
          arr.push(JSON.stringify(e))
        })
      }
      if (this.fixExcludeAnyFilter.length > 0) {
        this.fixExcludeAnyFilter.forEach((e: any) => {
          arr.push(JSON.stringify(e))
        })
      }
      if (this.topicFilter.length > 0 || this.searchText !== '' || this.fixIncludeAnyFilter.length > 0 || this.fixExcludeAnyFilter.length > 0) {
        this.filterQuery = this.filterQuery + `&keywords=[${arr}]`;
      }
      if (this.serpScoreFilter.length > 0) {
        if (this.serpScoreFilter.includes("High")) {
          this.filterQuery = this.filterQuery + `&serp_score=H`;
        }
        if (this.serpScoreFilter.includes("Medium")) {
          this.filterQuery = this.filterQuery + `&serp_score=M`;
        }
        if (this.serpScoreFilter.includes("Low")) {
          this.filterQuery = this.filterQuery + `&serp_score=L`;
        }
      }
      if (this.statusFilter.length > 0) {
        let status;
        if (this.statusFilter.includes("analyzed")) {
          status = `status_analyzed=true`;
        } else {
          status = `status_analyzed=false`;
        }
        this.filterQuery = this.filterQuery + `&${status}`;
      }
      if (this.topicFilter.length > 0) {
        this.filterQuery = this.filterQuery + `&topics=${this.topicFilter}`
      }
      if (this.searchText !== '') {
        this.filterQuery = this.filterQuery + `&search=${this.searchText}`
      }
      if (this.activateLink === "paa") {
        this.filterQuery = this.filterQuery + `&active=paa`

      } else if (this.activateLink === "related_search") {
        this.filterQuery = this.filterQuery + `&active=related_search`

      } else if (this.activateLink === "competition") {
        this.filterQuery = this.filterQuery + `&active=competition`

      } else if (this.activateLink === 'clusters') {
        this.filterQuery = this.filterQuery + `&active=cluster`


      }
      this.location.replaceState(`/lckr/reports/dashboard2/${this.keyWordId}?${this.filterQuery}`);
      if (this.activateLink === "paa") {
        this.getPaaData();
      } else if (this.activateLink === "related_search") {
        this.getRelatedData();
      } else if (this.activateLink === "competition") {
        this.getCompititorsData();
      } else if (this.activateLink === 'clusters') {
        // this.filterQuery = this.filterQuery + `&cluster_type=table_view&cluster_main_weakspot=${this.SERPSimilarity}`;
        this.getClusters();
      } else {
        this.getDashboardData();
      }
    } else {
      this.filterQuery = `page=${this.page}&lid=${this.keyWordId}&page_size=${this.tableSize}`;
      this.getListData()
    }

  }
  addTabType() {
    switch (this.activateLink) {
      case "suggestion":
        return `&type=S`;
      case "question":
        return `&type=Q`
      case "hidden":
        return `&hidden=True`
      default:
        return null;
    }
  }
  getPaaData() {
    this.lckrService.getPaa(this.keyWordId, this.filterQuery).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      res.results.forEach((el: any) => {
        el['isChecked'] = (!!this.checkArr.includes(el.id) || !!this.allSelect) ? true : false
      });
      this.allCount = res.count
      this.allPaginateData = res.results;
      this.loading = false;
      this.changePaginateData();
      this.masterSelected = (!this.allSelect && this.allPaginateData.every(e => !!e.isChecked)) ? true : false
    })
  }
  getRelatedData() {
    this.lckrService.getRelatedSearches(this.keyWordId, this.filterQuery).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      res.results.forEach((el: any) => {
        el['isChecked'] = (!!this.checkArr.includes(el.id) || !!this.allSelect) ? true : false
      });
      this.allCount = res.count
      this.allPaginateData = res.results;
      this.loading = false;
      this.changePaginateData();
      this.masterSelected = (!this.allSelect && this.allPaginateData.every(e => !!e.isChecked)) ? true : false
    })
  }
  getCompititorsData() {
    this.lckrService.getCompititors(this.keyWordId, this.filterQuery).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      res.results = res.results.map((el: any) => {
        return { text: el, isChecked: false }
      });
      this.allCount = res.count
      this.allPaginateData = res.results;
      this.loading = false;
      this.changePaginateData();
      this.masterSelected = (!this.allSelect && this.allPaginateData.every(e => !!e.isChecked)) ? true : false
    })
  }
  async getClusters() {
    this.lckrService.getClusters(this.keyWordId, this.filterQuery).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      res.results = res.results.map((el: any) => {
        return { text: el, isChecked: false }
      });
      this.allCount = res.count
      this.allPaginateData = res.results;
      this.loading = false;
      this.clustersloading = false;
      this.calculateCluters();
      this.getTabsCount();
      this.changePaginateData();
      this.masterSelected = (!this.allSelect && this.allPaginateData.every(e => !!e.isChecked)) ? true : false
    })
  }
  startClusturing() {
    this.clustersloading = true;
    this.lckrService.startClusters({ "lid": this.keyWordId, "serp_similarity": Number(this.SERPSimilarity) }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (!!res) {
        // this.loading = false;
        this.getClusters();
      }
    })
  }
  getTabsCount() {
    this.lckrService.getTabCount(this.keyWordId).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.lckrCountData = res
    })
  }
  calculateCluters(obj?: any, selected?: boolean) {
    if (!!obj) {
      obj.forEach((el: any) => {
        if (!!selected) {
          el['isChecked'] = this.selectedSubClusterId.includes(el.keyword) ? true : false
        } else {
          el['isChecked'] = (!!this.checkArr.includes(el.id) || !!this.allSelect) ? true : false
        }
        // 
        if (el.serp.length > 0) {
          el['serpPosition'] = el.serp.map((e: any) => {
            let positionArr: any = [];
            let keys = Object.keys(e).filter(k => e[k] === true);
            if (keys.length === 0) {
              positionArr = [{ key: "all false", da: {} }];
            } else {
              for (const key in e) {
                if (typeof e[key] == "boolean") {
                  if (e[key] == true) {
                    if (positionArr.length == 0) {
                      if (key === "lowda" && e.data_lowda.da < this.settingsData.maxDa) {
                        positionArr.push({ key: key, da: e.data_lowda });
                      } else {
                        positionArr.push({ key: key, da: {} });
                      }
                    }
                  }
                }
              }
            }
            return { domain: e.domain, isCustomDomain: this.settingsData.customDomain.includes(e.domain) ? true : false, isMySites: this.settingsData.mySites.includes(e.domain) ? true : false, title: e.title, link: e.link, position: e.position, serp: positionArr }
          })
        } else {
          el['serpPosition'] = []
        }
      })
    } else {
      this.allPaginateData.forEach(e => {
        e['isShow'] = false;
        let isSelected: boolean = false;
        if (this.selectedClusterId.includes(e.text.id)) {
          isSelected = true;
          e['isShow'] = true;
        } else {
          e['isShow'] = false;
        }
        for (let key in e.text) {
          if (key === 'keywords') {
            this.calculateCluters(e.text[key], isSelected)
          }
        }
      })
    }
  }
  refresh() {
    this.loading = true;
    if (!!this.keyWordId && this.keyWordType != 'list') {
      this.restoreState();
      this.compareAndSetSettings();
      this.getTabsCount();
      this.gettopicdata();
      this.getListNames();
      this.getExcludes();
    }
  }
  createContentEditor() {
    let modalRef = this.modal.open(BulkContentEditorComponent, { centered: true, windowClass: !this.theme ? 'dark-modal custom-modal' : 'custom-modal' });
    modalRef.componentInstance.country = "United States";
    modalRef.componentInstance.language = "en";
    modalRef.componentInstance.queryData = this.selectedSubClusterId;
    modalRef.result.then(e => {
      if (!!e && e !== undefined) {
        let obj = {
          "type": "POST",
          "uid": this.uid,
          "bulkAry": e,
          "retry": "false",
          "aid": "",
          "bulk": "true"
        }
        this.editorServie.addContentEditorData(obj).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
          if (res?.message && res.status == false) {
            // this.toster.error(res.message)
          }
          if (!!res && res?.aid?.length > 0) {
            res.aid.forEach((el: any) => {
              this.socket.emit("updater", el);
            });
            let index = this.paginateData.findIndex((e: any) => {
              return e.text.id === this.selectedClusterId[0];
            });
            this.paginateData[index].text.keywords.forEach((data: any) => {
              data.isChecked = false;
            })
            this.selectedSubClusterId = [];
            this.toastr.success("Content editor created successfully")
            // window.open(`${window.location.origin}/dashboard/content-editor/editors`, '_blank')
          }
        });
      }
    });
  }
  selectCluters(id: any) {

    if (!this.selectedClusterId.includes(id)) {
      if (this.selectedClusterId.length > 0) {
        let index = this.paginateData.findIndex((e: any) => {
          return e.text.id === this.selectedClusterId[0];
        });
        this.paginateData[index].text.keywords.forEach((data: any) => {
          data.isChecked = false;
        })
      }
      this.selectedClusterId = [];
      this.selectedClusterId.push(id);
      let selectedData = this.paginateData.find((el: any) => { return el.text.id === this.selectedClusterId[0] });
      this.selectedSubClusterId = selectedData.text.keywords.filter((ell: any) => { return ell.isChecked === true }).map((e: any) => { return e.keyword });
      // this.selectedSubClusterId  = 
    } else {
      let selectedData = this.paginateData.find((el: any) => { return el.text.id === id });
      this.selectedSubClusterId = selectedData.text.keywords.filter((ell: any) => { return ell.isChecked === true }).map((e: any) => { return e.keyword });
    }
  }
}
